import type { SupervisorQueues } from "@/types/supervisor";

export const supervisorQueues: SupervisorQueues[] = [
  { id: "dashboard", label: "Dashboard", icon: "layout-dashboard", count: 0 },
  { id: "workload", label: "Team Workload", icon: "users", count: 0 },
  { id: "escalations", label: "Escalations", icon: "alert-triangle", count: 0 },
  { id: "approvals", label: "Pending Approvals", icon: "check-square", count: 0 },
  { id: "departments", label: "Departments", icon: "building", count: 0 },
];
